module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t('Login')))]), _c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-sm-2"
  }, [_vm._v(" ")]), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('div', {
    staticClass: "box login-box text-center"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('Need to login')))]), _c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label"
  }, [_vm._v(_vm._s(_vm.$t('Login ID')))]), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.loginId),
      expression: "loginId"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "login_id",
      "type": "text",
      "name": "loginId"
    },
    domProps: {
      "value": _vm._s(_vm.loginId)
    },
    on: {
      "keyup": function($event) {
        if (_vm._k($event.keyCode, "enter", 13)) { return; }
        _vm.login($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.loginId = $event.target.value
      }
    }
  })])]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label"
  }, [_vm._v(_vm._s(_vm.$t('Password')))]), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "password",
      "type": "password",
      "name": "password"
    },
    domProps: {
      "value": _vm._s(_vm.password)
    },
    on: {
      "keyup": function($event) {
        if (_vm._k($event.keyCode, "enter", 13)) { return; }
        _vm.login($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })])]), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }), _c('div', {
    staticClass: "col-sm-7 text-left"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.keepLogin),
      expression: "keepLogin"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.keepLogin) ? _vm._i(_vm.keepLogin, null) > -1 : (_vm.keepLogin)
    },
    on: {
      "click": function($event) {
        var $$a = _vm.keepLogin,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.keepLogin = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.keepLogin = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.keepLogin = $$c
        }
      }
    }
  }), _c('span', [_vm._v("ログイン状態を保持")])])])]), _c('div', {
    staticClass: "form-group"
  }, [_c('a', {
    staticClass: "btn btn-success",
    attrs: {
      "id": "logion"
    },
    on: {
      "click": _vm.login
    }
  }, [_vm._v(_vm._s(_vm.$t('Login')))])]), _c('div', {
    staticClass: "form-group"
  }, [_c('router-link', {
    attrs: {
      "to": "/forgot_password"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('login.forgot_password')))])])], 1), (_vm.error) ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle"
  }), _c('span', [_vm._v(_vm._s(_vm.error))])]) : _vm._e()])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-36c02996!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./src/components/templates/login.pug
// module id = 374
// module chunks = 1